<template lang="pug">

  div

    //-
      -
      - BUSCA
      -
      -

    //- v-dialog(v-model="visible" max-width="500px" :persistent="searching")
    v-dialog(v-model="visible" max-width="560px" :persistent="searching")

      .dialogHeader

        .dialogHeaderTitle
          | Encontre um paciente

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="close")

      .dialogBody

        .dialogBodyContent

          //-
            -
            -
            - BUSCA
            -
            -
            -

          .searchInput

            input.searchField(v-model="searchTerm" type="text" :disabled="searching || loadingPage" maxlength="20" placeholder="Digite nome ou cpf entre 3 e 20 caracteres")

            .searchLoading(v-if="isValidSearchTerm && (searching /* || loadingPage */)")
              v-progress-circular(indeterminate color="red" size="25")

            sos-button(v-else :disabled="searching || loadingPage || !isValidSearchTerm" @buttonClick="search()" color="purple" size="small" buttonIcon="mdi-magnify" buttonIconSize="20")

          //-
            -
            -
            - NÃO ENCONTROU
            -
            -
            -

          .mt-3.pl-2

            span.patientPreRegisterAnchor(@click.stop.prevent="openPatientPreRegister")
              | Não encontrou o paciente? Clique aqui

          //-
            -
            -
            - RESULTADO DA BUSCA
            -
            -
            -

          template(v-if="!searching")

            template(v-if="foundPatientStatus === 'FOUND'")

              //-
                - RESULTADOS
                -

              .patientList.mt-3(:class="{ 'patientList--loading': loadingPage }")

                .patientListLoader(v-if="loadingPage")

                  .dialogLoaderCircle

                .patientListBody

                  .patientItem(v-for="(patient, patientIndex) in foundPatients" @click="onClickPatient(patient)" :key="patient.patientId || `patient_bug_${patientIndex}`" :class="{ 'patientItem--disabled': !!patient.patientId === false, 'patientItem--last': patientIndex === foundPatients.length - 1 }")

                    .patientTitle
                      | {{ patient.patientFirstName.length > 0 && patient.patientLastName.length > 0 ? `${patient.patientFirstName} ${patient.patientLastName}` : (patient.patientFirstName.length > 0 ? patient.patientFirstName : (patient.patientLastName || '')) }}

                    .patientDescription(:class="{ 'patientDescription--notFound': !!patient.patientGroup === false }")
                      i.mdi.mdi-city(aria-hidden="true")
                      | &nbsp;{{ patient.patientGroup || 'Grupo não encontrado' }}

              sos-navigation(v-if="pagesCount > 1" :disabled="loadingPage" :pagesCount="pagesCount" :pageNumber="pageNumber" @onClickPrevPageButton="onClickPrevPageButton" @onClickNextPageButton="onClickNextPageButton" @onClickPageButton="onClickPageButton")

              .foundUserTitle
                | {{ foundResults }} ocorrências

            //-
              - PACIENTE NÃO ENCONTRADO
              -

            template(v-else-if="foundPatientStatus === 'NOT_FOUND'")

              .foundUserTitle
                | Nenhum resultado

    //-
      -
      - Modal AVISO
      -
      -

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

    //-
      -
      - Modal de "PRÉ CADASTRO"
      -
      -

    dialog-create-patient(ref="dialogPatientPreRegister" @close="onCloseDialogPatientPreRegister")

</template>

<script>

  import { apiGetUserId } from '@/services/firebase'
  import { apiSearchPatients } from '@/services/consultations'

  import SosButton from '@/components/SosButton'
  import SosNavigation from '@/components/SosNavigation'

  import ConfirmDialog from '@/modals/ConfirmDialog'
  import DialogCreatePatient from '@/modals/DialogCreatePatient'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  //
  //
  //

  const extractDate = date => {
    const dateString = String(date).trim()

    // Verifica se a string tem o formato esperado
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\+\d{2}:\d{2}$/.test(dateString)) return '' // dateString

    // Extrai a parte antes do 'T'
    const datePart = dateString.split('T')[0]

    // Separa a data em partes (ano, mês, dia)
    const [year, month, day] = datePart.split('-')

    // Retorna no formato "dd/mm/yyyy"
    return `${day}/${month}/${year}`
  }

  //
  //
  //

  const cleanAndFormatCPF = cpf => {
    const stringCpf = String(cpf).trim()

    // Remove todos os caracteres não numéricos
    const cleanedCPF = stringCpf.replace(/\D/g, '')

    // Formata o CPF
    const formattedCPF = cleanedCPF.length === 11 ? cleanedCPF.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4') : ''

    return formattedCPF
  }

  //
  //
  //

  const pageSize = 10
  // const step = 3

  //
  //
  //

  export default {
    name: 'DialogFindPatient',

    components: {
      'sos-button': SosButton,
      'confirm-dialog': ConfirmDialog,
      'sos-navigation': SosNavigation,
      'dialog-create-patient': DialogCreatePatient,
    },

    mixins: [
      confirmDialogMixin,
    ],

    data () {
      return {
        visible: false,

        searching: false,
        loadingPage: false,

        searchTerm: '',

        foundPatientStatus: 'WAITING',
        foundPatients: [],

        foundResults: 0,

        pageNumber: 0,
        pagesCount: 0,
      }
    },

    computed: {
      isValidSearchTerm: function () {
        return String(this.searchTerm).trim().length >= 3
      },

      searchTermLowercase: function () {
        return String(this.searchTerm).trim().toLowerCase()
      },
    },

    watch: {
      visible: {
        // the callback will be called immediately after the start of the observation
        handler (currentVisible, previousVisible) {
          if (currentVisible === false) {
            this.clear()
          }
        },
      },
    },

    /* mounted () {
    },

    beforeDestroy () {
    }, */

    methods: {
      /**
       *
       * ABRE O "DialogFindPatient" (UMA ESPÉCIE DE "OnMounted")
       *
       */

      open () {
        this.visible = true
        this.clear()
      },

      close () {
        if (this.searching || this.loadingPage) return false

        this.visible = false
      },

      /**
       *
       * LIMPEZA
       *
       */

      clear () {
        this.searching = false
        this.loadingPage = false

        this.searchTerm = ''

        this.foundPatientStatus = 'WAITING'
        this.foundPatients = []

        this.foundResults = 0

        this.pageNumber = 0
        this.pagesCount = 0
      },

      //
      //
      //

      onClickPatient (patient)
      {
        if (this.loadingPage || !!patient.patientId === false) return false

        this.$emit('return', patient)

        this.clear()
        this.visible = false
      },

      //
      //
      //

      async onClickPrevPageButton (pageNumber)
      {
        await this.loadPage(pageNumber)
      },

      async onClickNextPageButton (pageNumber)
      {
        await this.loadPage(pageNumber)
      },

      async onClickPageButton (pageNumber)
      {
        await this.loadPage(pageNumber)
      },

      //
      //
      //

      openPatientPreRegister ()
      {
        this.$refs.dialogPatientPreRegister.open()
      },

      //
      //
      //

      async search ()
      {
        if (!this.isValidSearchTerm)
        {
          this.foundPatientStatus = 'WAITING'
          this.foundPatients = []

          return false
        }

        await this.loadPage(false)
      },

      //
      //
      //

      async loadPage (pageNumber = false)
      {
        if (pageNumber === false) {
          this.searching = true
        } else {
          this.loadingPage = true
        }

        const terms = window.btoa(unescape(encodeURIComponent(this.searchTermLowercase)))
        const offset = pageNumber <= 0 || pageNumber === false ? 0 : pageNumber * pageSize

        const request = await apiSearchPatients({ viewerID: apiGetUserId(), terms, offset, groupID: this.$route.params.groupID || '' })

        //
        // HOUVE ALGUM ERRO AO BUSCAR PACIENTE
        //

        if (request.httpCode !== 200)
        {
          this.foundPatientStatus = 'ERROR'
          this.foundPatients = []

          //
          // SINALIZA FIM DO CARREGAMENTO/PROCESSAMENTO PARA A TELA
          //

          if (pageNumber === false) {
            this.searching = false
          } else {
            this.loadingPage = false
          }

          return this.showMessage(request.title, request.message)
        }

        //
        // Success
        //

        const maxResults = request?.data?.total_results || 0
        const paginatedItems = request?.data?.paginated_items || []

        this.foundPatientStatus = paginatedItems.length > 0 ? 'FOUND' : 'NOT_FOUND'

        this.foundPatients = paginatedItems.length > 0 ? paginatedItems.map((patient, _) => ({
          patientId: !!patient.id === true && patient.id !== 'null' ? String(patient.id).trim() : '',
          patientFirstName: !!patient.first_name === true && patient.first_name !== 'null' ? String(patient.first_name).trim() : '',
          patientLastName: !!patient.last_name === true && patient.last_name !== 'null' ? String(patient.last_name).trim() : '',
          patientEmail: !!patient.email === true && patient.email !== 'null' ? String(patient.email).trim() : '',
          patientCpf: !!patient.cpf === true && patient.cpf !== 'null' ? cleanAndFormatCPF(patient.cpf) : '',
          patientDateOfBirth: !!patient.date_of_birth === true && patient.date_of_birth !== 'null' ? extractDate(patient.date_of_birth) : '',
          patientGroup: !!patient.group === true && patient.group !== 'null' ? String(patient.group).trim() : '',

          // Jesus
          // patientGroupId: '8ef9974b-3e79-4b37-971a-5687d1c2caf0',
          patientGroupId: !!patient.group_id === true && patient.group_id !== 'null' ? String(patient.group_id).trim() : '',
          // Jesus
        })) : []

        this.foundResults = maxResults

        //
        // SET PAGE / NAVIGATOR
        //

        this.pagesCount = Math.ceil(maxResults / pageSize)
        this.pageNumber = pageNumber || 0

        //
        // SINALIZA FIM DO CARREGAMENTO/PROCESSAMENTO PARA A TELA
        //

        if (pageNumber === false) {
          this.searching = false
        } else {
          this.loadingPage = false
        }
      },

      //
      //
      //
      //
      //

      onCloseDialogPatientPreRegister (patient)
      {
        if (patient === false) return false

        // [06/02/25] console.log('::: onCloseDialogPatientPreRegister:', patient)

        this.$emit('return', {
          patientId: !!patient.id === true && patient.id !== 'null' ? String(patient.id).trim() : '',
          patientFirstName: !!patient.first_name === true && patient.first_name !== 'null' ? String(patient.first_name).trim() : '',
          patientLastName: !!patient.last_name === true && patient.last_name !== 'null' ? String(patient.last_name).trim() : '',
          patientEmail: !!patient.email === true && patient.email !== 'null' ? String(patient.email).trim() : '',
          patientCpf: !!patient.cpf === true && patient.cpf !== 'null' ? cleanAndFormatCPF(patient.cpf) : '',
          patientDateOfBirth: !!patient.date_of_birth === true && patient.date_of_birth !== 'null' ? extractDate(patient.date_of_birth) : '',
          patientGroup: !!patient.group === true && patient.group !== 'null' ? String(patient.group).trim() : '',
          patientGroupId: !!patient.group_id === true && patient.group_id !== 'null' ? String(patient.group_id).trim() : '',
        })

        // phone, group_id

        this.clear()
        this.visible = false
      },

      /**
       *
       * CONFIRM DIALOG OUTPUT/RESPONSE
       *
       */

      cdAction (cdResponse)
      {
        // if (cdResponse === false) return false
      },
    },
  }

</script>

<style scoped lang="scss">

  .patientPreRegisterAnchor
  {
    transition-property: color;
    transition-duration: 200ms;

    cursor: pointer;

    color: midnightblue;
    font-size: 15px;
    font-weight: 500;

    &:hover {
      color: mediumslateblue;
      text-decoration: underline;
    }
  }

  //
  //
  //

  .patientListLoader {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    width: 28px;
    height: 28px;
    margin: auto;
  }

  .patientList {
    position: relative;

    max-height: 181px;
    overflow: auto;

    border-radius: 5px;
    border: 1px solid rgba(0, 0, 0, 0.15);

    &--loading
    {
      overflow: hidden;

      .patientListBody {
        opacity: 0.3;
      }
    }
  }

  .patientItem {
    cursor: pointer;

    position: relative;

    width: 100%;
    min-height: 40px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);

    &::before,
    &::after {
      transition-property: background-color;
      transition-duration: 150ms;

      content: "";

      position: absolute;
      width: 2px;
      background-color: transparent;
    }

    &::before {
      top: 19px;
      right: 19px;

      height: 6px;
      transform: rotate(-45deg);
    }

    &::after {
      top: 14px;
      right: 13px;

      height: 12px;
      transform: rotate(40deg);
    }

    &--last {
      border-bottom: 0;
    }

    &--disabled {
      cursor: not-allowed;

      opacity: 0.5;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.05);
    }
  }

  .patientTitle,
  .patientDescription {
    user-select: none;

    position: absolute;
    left: 0;

    display: inline-block;
    vertical-align: middle;
    width: 100%;
    padding-left: 12px;
    padding-right: 6px;

    line-height: 1.5;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .patientTitle {
    top: 2px;

    color: #555555;
    font-size: 14px;
    font-weight: 500;
  }

  .patientDescription {
    top: 19px;

    color: #808080;
    font-size: 12.5px;

    &--notFound {
      color: orangered;
    }
  }

  //
  //
  //

  .foundUserTitle {
    margin-top: 12px;

    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    text-align: right;
  }

  .searchFieldIcon {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto 0 !important;
    left: 12px;
  }

  .searchField {
    width: 100%;
    // max-width: 320px;
    height: 100%;
    background-color: #ffffff;
    padding: 0 56px 0 12px;
    // padding: 0 56px 0 40px;
    // padding: 0 20px 0 40px;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.25);
    outline: 0;
    // box-shadow: 1px 2px 2px -1px rgba(0, 0, 0, 0.25);
    font-size: 15px;

    &:disabled {
      // background-color: #CCCCCC;
      opacity: 0.5;
    }
  }

  .searchInput {
    position: relative;
    display: block;
    width: 100%;
    // max-width: 320px;
    height: 40px;

    .sosButton {
      position: absolute;
      top: 6px;
      right: 6px;
    }
  }

  .searchLoading {
    position: absolute;
    top: 7px;
    right: 7px;
    width: 25px;
    height: 25px;
  }

</style>
